/**
 * 作品详情页容器
 * @author wangychen
 * @since 2018/08/15
 */

import { connect } from 'react-redux';
import AppDetail from 'components/app-detail';

const mapStateToProps = (state, ownProps) => {
  const { baseInfo, banner } = state.appDetail;
  return { baseInfo, banner, ...ownProps };
};

export default connect(
  mapStateToProps,
  null
)(AppDetail);
